import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nft-10.png'
import _imports_1 from '@/assets/images/user-76.gif'
import _imports_2 from '@/assets/images/verify.svg'
import _imports_3 from '@/assets/images/nft-11.png'
import _imports_4 from '@/assets/images/user-77.gif'
import _imports_5 from '@/assets/images/nft-12.png'
import _imports_6 from '@/assets/images/user-85.png'
import _imports_7 from '@/assets/images/nft-13.png'
import _imports_8 from '@/assets/images/nft-14.png'
import _imports_9 from '@/assets/images/nft-3.gif'
import _imports_10 from '@/assets/images/nft-15.png'
import _imports_11 from '@/assets/images/nft-16.png'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_3 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_7 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_11 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_14 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_15 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_18 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_19 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_22 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_23 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_25 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_26 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_27 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_29 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_30 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_31 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35246"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Christmas Eve")
                ], -1)
              ])),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "9.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "5.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.2"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_3,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35247"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Humming Bird")
                ], -1)
              ])),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[9] || (_cache[9] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.5"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_5,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35228"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Naughty Pool")
                ], -1)
              ])),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "8.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createElementVNode("img", {
                src: _imports_7,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35227"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Hello Thumbs")
                ], -1)
              ])),
              _: 1
            }),
            _cache[17] || (_cache[17] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "9.30 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "8.15 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[19] || (_cache[19] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createElementVNode("img", {
                src: _imports_8,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35248"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Pixel Watermmelon")
                ], -1)
              ])),
              _: 1
            }),
            _cache[22] || (_cache[22] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "1.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "3.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[24] || (_cache[24] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("img", {
                src: _imports_9,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35258"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "BDancing Cookies")
                ], -1)
              ])),
              _: 1
            }),
            _cache[27] || (_cache[27] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[29] || (_cache[29] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createElementVNode("img", {
                src: _imports_10,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[31] || (_cache[31] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35158"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Rotating Flower")
                ], -1)
              ])),
              _: 1
            }),
            _cache[32] || (_cache[32] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[33] || (_cache[33] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode(" Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "3.95 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "6.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[34] || (_cache[34] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_RouterLink, {
            to: "/nft-marketplace/nft-details",
            class: "d-block mb-3 text-decoration-none position-relative"
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [
              _createElementVNode("img", {
                src: _imports_11,
                class: "rounded-3",
                alt: "nft"
              }, null, -1),
              _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/creator-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[36] || (_cache[36] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "rounded-circle",
                    style: {"width":"27px","height":"27px"},
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35782"),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Flying Bulb")
                ], -1)
              ])),
              _: 1
            }),
            _cache[37] || (_cache[37] = _createElementVNode("img", {
              src: _imports_2,
              class: "cursor",
              alt: "verify",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-title": "Verified"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_RouterLink, {
              to: "/nft-marketplace/nft-details",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => _cache[38] || (_cache[38] = [
                _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                    _createTextVNode("Highest Bid: "),
                    _createElementVNode("span", { class: "fw-semibold text-secondary" }, "8.75 ETH")
                  ]),
                  _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                ], -1)
              ])),
              _: 1
            }),
            _cache[39] || (_cache[39] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
              _createElementVNode("i", {
                class: "ri-heart-fill fs-20 position-relative top-2",
                style: {"color":"#ee3e08"}
              }),
              _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                _createTextVNode(" 9.7"),
                _createElementVNode("span", { class: "text-body" }, "/10")
              ])
            ], -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Pagination, {
      total: "30",
      items: "8",
      class: "mb-4"
    })
  ], 64))
}